var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25.6 25.6",
    style: {
      enableBackground: "new 0 0 25.6 25.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4,11.3H1.2v11.3c0,1,0.8,1.8,1.8,1.8h19.6c1,0,1.8-0.8,1.8-1.8L24.4,11.3z M7.1,5.4c-0.7,0-1.2,0.5-1.2,1.2 s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2S7.8,5.4,7.1,5.4z M18.4,5.4c-0.7,0-1.2,0.5-1.2,1.2s0.5,1.2,1.2,1.2s1.2-0.5,1.2-1.2 S19.1,5.4,18.4,5.4z M16.1,1.8c0.3,0,0.6,0.3,0.6,0.6S16.4,3,16.1,3H9.5C9.2,3,8.9,2.7,8.9,2.4s0.3-0.6,0.6-0.6H16.1z M22.6,1.8 c1.6,0,3,1.3,3,3v17.8c0,1.6-1.3,3-3,3H3c-1.6,0-3-1.3-3-3V4.8c0-1.6,1.3-3,3-3h1.8c0.3,0,0.6,0.3,0.6,0.6S5.1,3,4.8,3H3 C2,3,1.2,3.8,1.2,4.8v5.4h23.2V4.8c0-1-0.8-1.8-1.8-1.8h-1.8c-0.3,0-0.6-0.3-0.6-0.6s0.3-0.6,0.6-0.6H22.6z M7.1,0 c0.3,0,0.6,0.3,0.6,0.6v3.7c1,0.3,1.8,1.2,1.8,2.3C9.5,7.9,8.4,9,7.1,9C5.8,9,4.7,7.9,4.7,6.6c0-1.1,0.8-2,1.8-2.3V0.6 C6.5,0.3,6.8,0,7.1,0z M18.4,0C18.7,0,19,0.3,19,0.6v3.7c1,0.3,1.8,1.2,1.8,2.3c0,1.3-1.1,2.4-2.4,2.4C17.1,9,16,7.9,16,6.6 c0-1.1,0.8-2,1.8-2.3V0.6C17.9,0.3,18.1,0,18.4,0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCalendar);
export default __webpack_public_path__ + "static/media/ico-calendar.77aa7573fc1f4823524231b1c37414d9.svg";
export { ForwardRef as ReactComponent };